function getCorrectBgImage(element) {
    let bgImage = ''

    const customWidths = element.getAttribute('data-custom-widths')
    if (customWidths) {
        const maxWidthRatio = parseFloat(element.getAttribute('data-width-ratio') || "1")
        const containerWidth = (element.offsetWidth || window.innerWidth) * maxWidthRatio
        const desiredWidth = containerWidth * window.devicePixelRatio
        const widthsWithImages = JSON.parse(customWidths)
        const widths = Object.keys(widthsWithImages)
        for (let width of widths) {
            if (parseInt(width) >= desiredWidth) {
                bgImage = widthsWithImages[width]
                break
            }
        }

        if (!bgImage) {
            bgImage = widthsWithImages[widths[widths.length - 1]]
        }
    } else {
        const isTablet = window.matchMedia('(max-width: 800px)').matches
        //const isRetina2x = window.matchMedia('(-webkit-min-device-pixel-ratio: 2), (min-resolution: 2dppx), (min-resolution: 192dpi)').matches
        //const isRetina3x = window.matchMedia('(-webkit-min-device-pixel-ratio: 3), (min-resolution: 3dppx), (min-resolution: 350dpi)').matches
        const isRetina2x = window.devicePixelRatio > 1
        const isRetina3x = window.devicePixelRatio > 2

        const TabletImage = element.getAttribute('data-bg-tablet')
        const TabletImage2x = element.getAttribute('data-bg-tablet-2x')
        const TabletImage3x = element.getAttribute('data-bg-tablet-3x')

        const DesktopImage = element.getAttribute('data-bg-desktop')
        const DesktopImage2x = element.getAttribute('data-bg-desktop-2x')
        const DesktopImage3x = element.getAttribute('data-bg-desktop-3x')

        if (isTablet) {
            if (isRetina3x && TabletImage3x) {
                bgImage = TabletImage3x
            } else if ((isRetina3x || isRetina2x) && TabletImage2x) {
                bgImage = TabletImage2x
            } else if (TabletImage) {
                bgImage = TabletImage
            }
        }

        if (!bgImage) { // Desktop
            if (isRetina3x && DesktopImage3x) {
                bgImage = DesktopImage3x
            } else if ((isRetina3x || isRetina2x) && DesktopImage2x) {
                bgImage = DesktopImage2x
            } else if (DesktopImage) {
                bgImage = DesktopImage
            }
        }
    }

    return bgImage
}

function preloadHeroImage(bgImage, element, callback = undefined) {
    const img = new Image()
    img.onload = function () {
        // Once the image is loaded, set it as the background
        element.style.backgroundImage = `url('${bgImage}')`

        if (element.dataset.style) {
            try {
                const styleObj = JSON.parse(element.dataset.style)
                Object.keys(styleObj).map(key => {
                    element.style[key] = styleObj[key]
                })
            } catch(err) {
                console.error(err);
            }
        }

        // Optionally, you can add a class to indicate it's loaded
        element.classList.add('bg-loaded')
        if (callback) {
            callback()
        }
    }
    img.onerror = function () {
        console.error('Error loading background image:', bgImage)
        // Optionally handle the error (e.g., show a fallback)
        if (callback) {
            callback()
        }
    }
    img.src = bgImage
}

function initializeLazyLoading() {
    const lazyBackgrounds = document.getElementsByClassName('js-lazy-background')

    if ('IntersectionObserver' in window) {
        let lazyBackgroundObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    const element = entry.target
                    const bgImage = getCorrectBgImage(element)

                    if (bgImage) {
                        preloadHeroImage(bgImage, element, function () {
                            observer.unobserve(element)
                        })
                    }
                }
            })
        })

        for (let lazyBackground of lazyBackgrounds) {
            lazyBackgroundObserver.observe(lazyBackground)
        }
    } else {
        for (let lazyBackground of lazyBackgrounds) {
            const bgImage = getCorrectBgImage(lazyBackground)

            if (bgImage) {
                preloadHeroImage(bgImage, lazyBackground)
            }
        }
    }
}

const scrollSentinel = document.getElementById('scroll-sentinel')

const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
        if (!entry.isIntersecting) {
            document.body.classList.add('Layout--HeaderScrolled')
        } else {
            document.body.classList.remove('Layout--HeaderScrolled')
        }
    })
})

observer.observe(scrollSentinel)

initializeLazyLoading()
//})
